import Immutable from 'immutable';
import { RawRFI, RFI } from 'records/RFI';

export interface RawViewRFIList {
  type: string;
  rfis: RawRFI[];
  containerStyles: React.CSSProperties;
}

export interface ViewRFIListData {
  type: string;
  rfis: Immutable.List<RFI>;
  containerStyles: React.CSSProperties;
}

const defaultValues: ViewRFIListData = {
  type: 'ViewRFIList',
  rfis: Immutable.List(),
  containerStyles: {},
};

export const ViewRFIListFactory = Immutable.Record(
  defaultValues,
  'ViewRFIList'
);

export class ViewRFIList extends ViewRFIListFactory {
  serialize(): RawViewRFIList {
    return this.toJS();
  }

  static deserialize(rawViewRFIList: RawViewRFIList): ViewRFIList {
    return new ViewRFIList({
      ...rawViewRFIList,
      rfis: Immutable.List<RFI>(rawViewRFIList.rfis.map(RFI.deserialize)),
    });
  }
}
